import { useTranslation } from "react-i18next";
import styles from "./LeaveTip.module.scss";
import { useEffect, useRef } from "react";
import TransparentTile from "../../../TransparentTile/TransparentTile";
import TransparentTextField from "../../../TransparentTextField/TransparentTextField";
import TransparentButton from "../../../TransparentButton/TransparentButton";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";
import { TIP_PERCENTAGES, useTipDraft } from "@/store/useTipDraftStore";

function LeaveTip() {
  const { t } = useTranslation();
  const { selectedAmount, remainingAmount, setVenuesData } =
    useVenuesDataStore();
  // Held outside this component, so stepping forward to the payment method and
  // back does not lose what the guest picked.
  const { selectedTip, setSelectedTip, customTipValue, setCustomTipValue } =
    useTipDraft();

  const isCustomTip = selectedTip === t("gradientDrawer.leaveTip.customTip");

  const baseAmount =
    selectedAmount > 0 ? selectedAmount : remainingAmount / 100;

  const calculatedTip = (() => {
    if (isCustomTip) {
      const parsed = parseFloat(customTipValue);
      return isNaN(parsed) ? 0 : parsed;
    }
    if (selectedTip) {
      const percentage = parseFloat(selectedTip) / 100;
      return Math.round(baseAmount * percentage * 100) / 100;
    }
    return 0;
  })();

  // Blank the amount when the guest switches INTO custom, not when a custom
  // tip is restored: on mount that would wipe the very value being restored.
  const wasCustomTip = useRef(isCustomTip);
  useEffect(() => {
    if (isCustomTip && !wasCustomTip.current) {
      setCustomTipValue("");
    }
    wasCustomTip.current = isCustomTip;
  }, [isCustomTip]);


  useEffect(() => {
    setVenuesData({ tipAmount: calculatedTip });
  }, [calculatedTip, setVenuesData]);

  return (
    <div className={styles.leaveTipContent}>
      <p className={`title-large ${styles.leaveTipTitle}`}>
        {t("gradientDrawer.leaveTip.header.title")}
      </p>
      <TransparentTile>
        <div className={styles.leaveTipEnteredAmountContainer}>
          <p className={`body-medium ${styles.leaveTipEnteredAmountTitle}`}>
            {t("gradientDrawer.leaveTip.tipAmount")}
          </p>
          {isCustomTip ? (
            <TransparentTextField
              value={customTipValue}
              setValue={setCustomTipValue}
            />
          ) : (
            <p
              className={`headline-medium ${styles.leaveTipEnteredAmountPrice}`}
            >
              {calculatedTip.toFixed(2)} zł
            </p>
          )}
        </div>
      </TransparentTile>
      <div className={styles.leaveTipSmallButtonsContainer}>
        {/* 0% is one of the choices rather than a way out at the bottom of the
            screen, so leaving nothing takes the same single tap as leaving
            something. */}
        {TIP_PERCENTAGES.map((percent) => (
          <TransparentButton
            key={percent}
            setValue={setSelectedTip}
            text={`${percent}%`}
            selectedValue={selectedTip}
          />
        ))}
      </div>
      <TransparentButton
        setValue={setSelectedTip}
        text={t("gradientDrawer.leaveTip.customTip")}
        selectedValue={selectedTip}
      />
    </div>
  );
}
export default LeaveTip;
